import type { OperatingSystem } from "shared-core/types/operating-system";
import type { Platform } from "shared-core/types/platform";
import type { InjectionKey, MaybeRefOrGetter } from "vue";

export type { Platform };

export interface SeoHandler {
  setMeta: (meta: { title: MaybeRefOrGetter<string> }) => void;
}

export interface PlatformConfig {
  platform: Platform;
  /** Set by the agent; undefined on the web. */
  agentOperatingSystem?: OperatingSystem;
  openExternalUrl: (url: string) => Promise<void>;
  backendBaseUrl: string;
  seoHandler?: SeoHandler;
  controlaAppDomain?: string;
}

export const PlatformConfigKey: InjectionKey<PlatformConfig> =
  Symbol("platform-config");
